export default {
  init() {
    // editAccountForm();
    changeAddressFields();
  },
};

export var editAccountForm = () => {
  var shipping = $('#shipping_data input[type="text"]');
  var billing = $('#billing_data input[type="text"]');

  var shippingArray = new Array();
  var billingArray = new Array();

  for (var i = 0; i < shipping.length; i++) {
    shippingArray.push(shipping.eq(i).val());
  }

  for (var e = 0; e < billing.length; e++) {
    billingArray.push(shipping.eq(e).val());
  }

  if (billingArray.length == shippingArray.length) {
      document.getElementById('deliver_adress_same').checked = true;
  }
  else {
    document.getElementById('deliver_adress_same').checked = false;
  }

  $('#deliver_adress_same').change(function() {
      if(this.checked) {
        var shipping = $('#shipping_data input[type="text"]');
          for (var i = 0; i < shipping.length; i++) {
             var shippingValue = shipping.eq(i).val();
             var billingFieldId = $('#billing_data input[type="text"]')[i].id;
             $('#' + billingFieldId).val(shippingValue);
          }
      }
  });

document.getElementById('billing_data').addEventListener('change', function(event){
    const elem = event.target;
    if(elem.type === 'text'){
      document.getElementById('deliver_adress_same').checked = false;
    }
});

document.getElementById('shipping_data').addEventListener('change', function(event){
    const elem = event.target;
    if(elem.type === 'text'){
      document.getElementById('deliver_adress_same').checked = false;
    }
});
}

export var changeAddressFields = () => {
  changeTheAddressFields();

  $('#billing_country').on('change', function () {
    changeTheAddressFields();
  });

  function changeTheAddressFields() {
    let address1 = $('#billing_address_1_field');
    let address2 = $('#billing_address_2_field');
    let street = $('#billing_street_field');
    let houseNumber = $('#billing_house_number_field');

    let selectedCounty = $('#billing_country').val();

    switch (selectedCounty) {
      case 'NL':
      case 'DE':
      case 'BE':
        address1.hide();
        address2.hide();

        street.show();
        houseNumber.show();

        console.log('hide address, show custom');
        break;
      default:
        address1.show();
        address2.show();

        street.hide();
        houseNumber.hide();
        console.log('show address, hide custom');
        break;
    }
  }
}

